import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'antd';
import ModalCancel from './ModalCancel'
import ModalReservationVroom from './ModalReservationVroom'
import { get, head, lowerCase } from 'lodash'
import { CANCEL_RESERVATION } from '../../redux/actions/type'
import { checkTokenExpire } from '../../redux/actions/actions'
import { useDispatch, useSelector } from 'react-redux'
import {
    genVRoomToken, getTimeRemaining
} from '../../helpers'
import { translate } from 'react-i18next'

const ContentHeader = ({ reservationContent, activeItem, t }) => {
    const dispatch = useDispatch()
    const keycloak = useSelector(state => state.keycloak)


    const [modalCancel, setModalCancel] = useState(false)
    const [editReservation, setEditReservation] = useState({
        visible: false,
        action: null
    })

    const [timeCountdown, setTimeCoundown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    })

    const [dateNow, setdateNow] = useState(0)

    const name = get(reservationContent, '[0]name', '')
    const preStartDt = get(reservationContent, '[0]pre_start_dt', '')
    const startDt = get(reservationContent, '[0]start_dt', '')
    const endDt = get(reservationContent, '[0]end_dt', '')
    const status = get(reservationContent, '[0]status', '')

    const showCancelModal = () => {
        setModalCancel(true)
    };

    const hideCancelModal = () => {
        setModalCancel(false)
    };

    const onReservation = () => {
        dispatch(checkTokenExpire)
        setEditReservation({
            visible: true,
            action: 'edit'
        })
    }

    const onCancelReservation = () => {
        dispatch(checkTokenExpire)
        dispatch({
            type: CANCEL_RESERVATION,
            payload: {
                id: activeItem
            }
        })
        hideCancelModal()
    }

    const onCreateRoom = async () => {
        dispatch(checkTokenExpire)
        const room = reservationContent[0].name
        const vRoomToken = await genVRoomToken(keycloak)
        window.location.href = `${window._env_.vRoomUrl}/${room}?jwt=${vRoomToken}`
    }

    const isCountDown = () => {
        return preStartDt >= dateNow
    }

    const isCreateRoom = () => {
        return preStartDt < dateNow && endDt > dateNow
    }

    useEffect(() => {
        let timeInterval = setInterval(function () {
            const { total, days, hours, minutes, seconds } = getTimeRemaining(startDt)
            if (total > 0) {
                setTimeCoundown({
                    days: days,
                    hours,
                    minutes,
                    seconds
                })
            }
            setdateNow(Date.parse(new Date()))
        }, 1000);


        return () => {
            clearInterval(timeInterval)
            setTimeCoundown({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            })
        };
    }, [startDt]);

    const { days, hours, minutes, seconds } = timeCountdown

    return (
        <>
            <Row className="reservation-content-header">
                <Col xl={13} lg={8} md={24}><h3 className="text-header">{name}</h3></Col>
                <Col xl={11} lg={16} md={24} className="reservation-content-header-right">
                    {
                        isCountDown() ? (
                            <Col className="time-count-down-vroom">
                                <div className="time-count-date">
                                    <label>{t('date_countdown')}</label>
                                    <span>
                                        {
                                            days >= 99 ? '99+' : days.toString().padStart(2, '0')
                                        }
                                    </span>
                                </div>
                                <div className="time-count-border" />
                                <div className="time-count-time">
                                    <label>{t('time_countdown')}</label>
                                    <span>{`${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`}</span>
                                </div>
                            </Col>
                        ) : null
                    }

                    {
                        isCreateRoom() ? (
                            <Button className="btn-create-vroom-meet" onClick={onCreateRoom}>{t('reservation_button_create_room')}</Button>
                        ) : null
                    }

                    <Button className="btn-edit-vroom-meet" onClick={onReservation}>{t('reservation_button_edit_room')}</Button>

                    {
                        lowerCase(status) === 'schedule' ? (
                            <>
                                <Button onClick={showCancelModal} className="btn-cancel-vroom-meet">{t('reservation_button_cancel_room')} </Button>
                            </>
                        ) : null
                    }

                    {
                        lowerCase(status) === 'finish' ? (
                            <div className="btn-finish-vroom-meet">{t('reservation_button_finish_meet')}</div>
                        ) : null
                    }

                    {
                        lowerCase(status) === 'expire' ? (
                            <div className="btn-finish-vroom-meet">{t('reservation_button_expire_meet')}</div>
                        ) : null
                    }
                </Col>
                <ModalCancel
                    modalCancel={modalCancel}
                    hideCancelModal={hideCancelModal}
                    onCancelReservation={onCancelReservation}
                />
                <ModalReservationVroom
                    visible={editReservation.visible}
                    title={t("reservation_modal_form.header_edit")}
                    setReservation={setEditReservation}
                    action={editReservation.action}
                    reservObj={head(reservationContent)}
                />
            </Row>
        </>
    )
}

export default translate()(ContentHeader)
